import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { SUITE_NAME, pageTitle } from "../../brand";

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    background: "#0f172a",
    color: "#e2e8f0",
    textAlign: "center",
  },
  code: {
    margin: 0,
    fontSize: "0.85rem",
    fontWeight: 700,
    letterSpacing: "0.12em",
    color: "#60a5fa",
  },
  title: { margin: "8px 0", fontSize: "1.6rem", fontWeight: 650 },
  text: { margin: "0 0 24px", color: "#a3b1c4" },
  link: {
    display: "inline-block",
    padding: "10px 18px",
    borderRadius: 8,
    background: "#ffffff",
    color: "#0b1f3a",
    fontWeight: 600,
    textDecoration: "none",
  },
};

export default function NotFound() {
  return (
    <main style={styles.page}>
      <Helmet>
        <title>{pageTitle("Page not found")}</title>
      </Helmet>
      <div>
        <p style={styles.code}>404</p>
        <h1 style={styles.title}>This page doesn&apos;t exist</h1>
        <p style={styles.text}>
          The link may be old or mistyped. Go back to {SUITE_NAME} to find what
          you need.
        </p>
        <Link to="/" style={styles.link}>
          Back to {SUITE_NAME}
        </Link>
      </div>
    </main>
  );
}
